export class OrderPaymentCardCreation {
  constructor(data) {
    /** @type {null | number} */
    this.paymentProfileId = data.paymentProfileId;
    this.groupAdminId = data.groupAdminId;

    /** Can be null. */
    this.card = {
      type: data.card.type,
      billingAddress: data.card.billingAddress,
      billingZip: data.card.billingZip,
      isSaveCard: data.card.isSaveCard,
      token: data.card.token,
      name: data.card.name,
    };
  }
}
